/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Flat_Seal_ClapInputs */

const en_full_flat_seal_clap = /** @type {(inputs: Full_Flat_Seal_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for data`)
};

const de_full_flat_seal_clap = /** @type {(inputs: Full_Flat_Seal_ClapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warte auf Daten`)
};

/**
* | output |
* | --- |
* | "Waiting for data" |
*
* @param {Full_Flat_Seal_ClapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_flat_seal_clap = /** @type {((inputs?: Full_Flat_Seal_ClapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Flat_Seal_ClapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_flat_seal_clap(inputs)
	return de_full_flat_seal_clap(inputs)
});